import { formatUnit } from '@dynatrace-sdk/units';

import type { ChartUnit } from '../types/chart-unit.js';
import { isUnit } from '../types/formatter.js';

export function getUnitAsString(unit: ChartUnit) {
  if (!unit) {
    return '';
  }

  if (isUnit(unit)) {
    return formatUnit(unit);
  }

  return unit.toString();
}
